import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./styles/Cart.css";
import WebsiteFooter from "../components/WebsiteFooter";
import CartCard from "../components/CartCard";
import database from "../config/firebaseConfig";  

const Cart = ({ cart, updateCartQuantity, loggedInUser }) => {
  const navigate = useNavigate();
  const [productsMap, setProductsMap] = useState({});
  const [netValues, setNetValues] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const snapshot = await database.ref("Products").once("value");
        if (snapshot.exists()) {
          const allProducts = snapshot.val();
          const productLookup = {};
          Object.keys(allProducts).forEach((key) => {
            productLookup[allProducts[key].Name] = allProducts[key];
          });
          setProductsMap(productLookup);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    if (!cart || cart.length === 0) {
      return;
    }

    let netValue = { Weight: 0, Amount: 0 };

    cart.forEach(item => {
      netValue.Weight += (item.Weight || 0) * (item.quantity || 1); // Ensure safe addition if Net_Wt is undefined
      netValue.Amount += (item.Price || 0) * (item.quantity || 1); // Account for quantity
    });

    setNetValues(netValue);
  }, [cart, setNetValues]);

  const handleNavigation = (path) => {
    if(loggedInUser){
      navigate(path);
    }else{
      navigate('/Login')
    } 
  };

  return (
    <>
      <div className="collections-container">
        <h1>Your Cart</h1>
        {cart.length === 0 ? (
          <p>Your cart is empty.</p>
        ) : (
          <div className="cart-container">
            {cart.map((item, index) => (
              <div key={index}>
                <CartCard key={index + "card"} index={index} item={item} updateCartQuantity={updateCartQuantity} onClick={() => handleNavigation(`/Product/${item.Name}`)} products={productsMap} />
                <hr key={index + "hr"} />
              </div>
            ))}
            <span className="totels">
              <div>Total Weight: <strong> {netValues && netValues.Weight/1000} Kg</strong></div>
              <div>Total: <strong>Rs. {netValues && netValues.Amount}</strong></div>
            </span>
            <br />
            <button
              className="checkout-button"
              onClick={() => handleNavigation(`/Checkout`)}
            >
              Proceed to Checkout
            </button> <br /><br /><br /><br />
          </div>
        )}
      </div>
      <WebsiteFooter />
    </>
  );
};

export default Cart;
